import { AxiosError } from 'axios';
import { createMutation } from 'react-query-kit';

import { ErrorResponse, privateApi } from 'api';

export interface UpdateEmailTemplateParams {
  templateKey: 'form-issued' | 'welcome-letter';
  id: string;
  template: EmailTemplate;
}

async function updateEmailTemplate(params: UpdateEmailTemplateParams): Promise<EmailTemplate> {
  const { templateKey, id, template } = params;

  // make api call
  const result = await privateApi.put<EmailTemplate>(
    `${import.meta.env.VITE_API_BASE_URL}/templates/${templateKey}/${id}`,
    {
      email: template,
    },
  );

  return result.data;
}

const useUpdateEmailTemplate = createMutation<EmailTemplate, UpdateEmailTemplateParams, AxiosError<ErrorResponse>>({
  mutationFn: async (variables) => updateEmailTemplate(variables),
});

export { updateEmailTemplate, useUpdateEmailTemplate };
